<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { RemoteIcon } from "@infinitro/icons";
export let icon = null;
export let activeTab = false;
export let inactiveTab = false;
export let iconCustomStyles = "";
</script>

{#if typeof icon === 'string'}
	{#if icon.endsWith('.svg') || icon.endsWith('.png') || icon.endsWith('.jpg')}
		<img
			src={icon}
			alt={$t(Verbiage.icon_alt, 'alts')}
			class="icon"
			style={iconCustomStyles}
			class:icon-inactive={inactiveTab}
			class:icon-active={activeTab}
		/>
	{:else if $stateUi.layout.useRemoteIcons === true && typeof icon === 'string'}
		<RemoteIcon {icon} size={20} />
	{:else}
		<i class={icon} style={iconCustomStyles}></i>
	{/if}
{:else if icon != null && typeof icon !== 'string'}
	{@const Icon = icon}
	<span class="icon" style={iconCustomStyles}>
		<Icon hover={activeTab} size={20} />
	</span>
{/if}

<style>
	.icon {
    display: flex;
    width: 16px;
    align-items: center;
    justify-content: center
}
	.icon-inactive {
    opacity: 0.6
}
	.icon-inactive:hover {
    opacity: 1
}
	.icon-active {
    opacity: 1
}
</style>
